'use client';

import s from 'Workadabra/app/[lang]/home/sections/trust/styles.module.css';
import { rdTrustEscrowBody, rdTrustEscrowTitle, rdTrustHeading, rdTrustLocalBody, rdTrustLocalTitle, rdTrustPayBody, rdTrustPayTitle, rdTrustSub, rdTrustVerifiedBody, rdTrustVerifiedTitle } from 'Workadabra/translations';
import { getLanguageFromLocale } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';

export const TrustSection = () => {
  const params = useParams();
  const language = getLanguageFromLocale(params?.lang as string);

  const values = [
    { body: rdTrustVerifiedBody[language], icon: '🛡️', testId: 'value-verified', title: rdTrustVerifiedTitle[language] },
    { body: rdTrustEscrowBody[language], icon: '🔒', testId: 'value-escrow', title: rdTrustEscrowTitle[language] },
    { body: rdTrustPayBody[language], icon: '💳', testId: 'value-pay', title: rdTrustPayTitle[language] },
    { body: rdTrustLocalBody[language], icon: '📍', testId: 'value-local', title: rdTrustLocalTitle[language] },
  ];

  return (
    <section className={s.root} data-testid='trust-section' id='trust'>
      <div className={s.head}>
        <h2 className={s.heading}>{rdTrustHeading[language]}</h2>
        <p className={s.sub}>{rdTrustSub[language]}</p>
      </div>
      <div className={s.grid}>
        {values.map(value => (
          <div className={s.card} data-testid={value.testId} key={value.testId}>
            <div className={s.icon}>{value.icon}</div>
            <h3 className={s.cardTitle}>{value.title}</h3>
            <p className={s.body}>{value.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
